import tr008 from "./tr008";
import abbtxnerror from "./abbtxnerror"
import ms234 from "./ms234";
import tr002 from "./tr002";
import tr004 from "./tr004";
import tr008d from "./tr008d";
import tr013 from "./tr013";
import benificiarydetails from "./benificiarydetails"
import tr026 from "./tr026";
import tr027 from "./tr027";
import tr028 from "./tr028";
import tr051 from "./tr051";
import demanddraftdetails from "./demanddraftdetails";
import tr027details from "./tr027details";
import tr046 from "./tr046"
import pmsby from "./pmsby"
import pmjjby from "./pmjjby"
import termdeposit2 from "./termdeposit2"

import tr307 from "./tr307";
import tr306 from "./tr306";
import sv301 from "./sv301";
import cr from "./cr";

export default {sv301,cr,
tr306,
tr307,
 tr008, abbtxnerror,ms234,tr002 ,tr004,tr008d,tr013,benificiarydetails,tr026,tr027,tr028,tr051,demanddraftdetails,tr027details,tr046,pmsby,pmjjby,termdeposit2};